import { Component, OnInit, OnChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {GridsterComponent, GridsterConfig, GridsterItemComponent} from 'angular-gridster2';
import { catchError, forkJoin, from, lastValueFrom, map, of, switchMap, tap } from 'rxjs';
import { findItem, getGridsterOptions } from '@core/_utils/tools.utils';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { RequestTools } from '@service/request.tools';
import { BskselectComponent } from '@documalis/bskselect/bskselect.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { ListboxModule } from 'primeng/listbox';
import { KeyDetailDocks } from '@documalis/_const/const';

@Component({
    standalone: true,
    selector: 'page-param-docks-pos',
    imports: [
        BskselectComponent,
        DropdownModule,
        ButtonModule,
        TranslateModule,
        GridsterComponent,
        GridsterItemComponent,
        NgClass,
        SkeletonModule,
        TableModule,
        DialogModule,
        FormsModule,
        InputTextModule,
        ListboxModule
    ],  
    templateUrl: 'page-param-docks-pos.component.html',
    styleUrls: ['page-param-docks-pos.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PageParamDocksPosComponent implements OnInit, OnChanges {
    public options: GridsterConfig;
    public dockBase = [];
    public displayList = [];
    public selectedDisplay: number | string  = -1;
    private maxItemCols = 32;
    private minItemCols = 4;
    private minItemRows = 1;
    private colBase = 16;
    public lines: any[] | undefined;
    public dockType = 0;
    public customModel: boolean = false;
    public docks: any[] | undefined;
    public dockList: any[] | undefined;
    public docksDetails: any[] | undefined;
    public displayName: boolean = false;
    public displayBsk: boolean = false;
    public displayDock: boolean = false;    
    public modelName: string = '';
    public basketList = [];
    public selectedDock: any[] | undefined;
    private basketMailList = [];
    private basketCollectList = [];
    private basketPublishList = [];
    private basketActionList = [];
    private basketInputList = [];
    private basketOutputList = [];
    private basketSystemList = [];

    private bskCollect = [];
    private bskAction = [];
    private bskInvoiceValidation = [];
    private bskMailDispatching = [];
    private bskMailValidation = [];
    private bskMailReordering = [];

    @ViewChild('bskselect') public bskselect: BskselectComponent;

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected messageService: MessagesService,
        private _translate: TranslateService,
        private requestTools: RequestTools,
    ) {
        this.menu.display = true;
        this.dockList = [];
        this.selectedDock = [];
        this.selectedDisplay = -1;
    }

    public ngOnInit() {
        this.lines = Array.from({ length: 5 }).map((_, i) => `Item #${i}`);
        this.options = getGridsterOptions(false, null, "always");        
        this.getDisplayList();
        this.manageDock(true);        
        this.getDocks().subscribe();
    }

    private getDocks() {
        // Lecture de la liste des docks
        return from(this.getAllDocks()).pipe(
            map(result => {
                result.forEach(element => {
                    // Maj de la liste avec les docks préenregistrés
                    this.updateDisplayList(element.name, element.id);                 
                })
             }),
            catchError((error: any) => {
                console.log(error);
                return of(null);
            }))
            .pipe(
                switchMap(() => {return this.fetchAdditionalData()}                
            )
        );        
    }

    private fetchAdditionalData() {
        return forkJoin([
            // Récupération de la liste des bannettes avec regroupement par type de dock
            this.getBasketList(),
            // Récupération des docks custom
            this.getDockList(),
            // Récupération de la liste des docks affectés aux bannettes
            this.getDocksDetails()
        ]);
    }

    private updateDisplayList(aName: string, aId: number) {
        let wIndex = -1;
        let wName = '';
        let wCount = 0;
        wIndex = findItem(this.displayList, aName, 'key');
        if (wIndex === -1) {
            wName = this.getDisplayName(aName);
            wCount = this.displayList.length;
            this.displayList.push({ key: aName, label: wName, value: wCount, id: aId });
        } else {
            this.displayList[wIndex].id = aId;
        }   
    }

    private getDisplayName(aName) {
        let index: number = aName.indexOf('@');
        return aName.substring(index + 1);
    }

    public ngOnChanges() {}

    public manageDock(reorgBsk) {
        this.options.draggable.enabled = reorgBsk;
        this.options.resizable.enabled = reorgBsk;
        if (this.options.api && this.options.api.optionsChanged) {
            this.options.api.optionsChanged();
        }
    }

    public onChange($event) {
        this.loadDocks(this.selectedDisplay);
        this.setBasketList(this.dockType);
    }

    public addMod() {
        this.displayName = true;
    }

    public addDock() {
        this.displayDock = true;
    }
    
    public applyBsk() {
        let wBsk = [];
        this.docksDetails.forEach(element => {
            wBsk.push(element.bskname);
        })
        if (this.basketList.length > 0) {
            this.displayBsk = true;
            this.bskselect.updateSelectedRows(wBsk);
        } else {
            this.messageService.addErrorMsg(this._translate.instant('Dock_NoBsk'));
        }
    }

    public onApplyBsk($event) {
        let wBasketList = [];
        wBasketList = this.bskselect.getBasketList();
        if (wBasketList.length === 0) {
            return;
        } else {
            this.saveBasketPos(wBasketList);
        }
    }

    private async saveBasketPos(aBasketList) {
        let wId = 0;
        let wKey = '';
        const aId = findItem(this.displayList, this.selectedDisplay, 'value');
        if (aId !== -1) {
            wId = this.displayList[aId].id;
            wKey = this.displayList[aId].key;
            await this.execSaveBasketPos(aBasketList, wId, wKey);
            this.displayBsk = false;
            this.getDocks().subscribe();
        }
    }

    public onSave($event) {
        if (this.modelName.trim() === '') {
            return;
        }
        if (this.modelExist() === true) {
            this.messageService.addErrorMsg(this._translate.instant('Dock_Exist'));
            return;
        }
        this.saveModel($event);
    }

    public async delMod() {
        let wId = 0;
        let wKey = '';
        const aId = findItem(this.displayList, this.selectedDisplay, 'value');
        if (aId !== -1) {
            wId = this.displayList[aId].id;
            wKey = this.displayList[aId].key;
        }
        await this.execDeleteDock(wId, wKey);
        const result = await this.getAllDocks();
        this.setDisplayList(result);
    }

    private setDisplayList(aList) {
        try {
            aList.forEach(element => {
                this.updateDisplayList(element.name, element.id);                 
            })            
        } catch (error) {
            console.log(error);
        }
    }

    private modelExist() {
        let wIndex = -1;
        wIndex = findItem(this.displayList, this.modelName, 'value');
        if (wIndex !== -1) {
            return true;
        } else {
            return false;
        }
    }

    private async saveModel($event) {
        let wIndex = -1;
        await this.execSave($event, this.modelName);
        wIndex = findItem(this.displayList, this.modelName, 'label');
        if (wIndex !== -1) {
            this.selectedDisplay = wIndex;
            this.onChange(this.selectedDisplay);
        }
    }

    public async applyDetail() {        
        let wId = 0;
        let wKey = '';
        const aId = findItem(this.displayList, this.selectedDisplay, 'value');
        if (aId !== -1) {
            wId = this.displayList[aId].id;
            wKey = this.displayList[aId].key;
            await this.execSaveDetailPos(KeyDetailDocks, wId, wKey);
        }        
    }

    public closeSave() {
        this.displayName = false;
    }

    public closeApplyBsk() {
        this.displayBsk = false;
    }

    public closeAddDock() {
        this.selectedDock = [];
        this.displayDock = false;
    }

    public savePos($event, aModelName) {
        this.execSave($event, aModelName);
    }

    private async execSave($event, aModelName) {
        let wId = 0;
        let wKey = '';
        let wRes = [];
        if (aModelName === '') {            
            const aId = findItem(this.displayList, this.selectedDisplay, 'value');
            if (aId !== -1) {
                wId = this.displayList[aId].id;
                wKey = this.displayList[aId].key;
            }
        }
        await this.execSaveDock(this.dockBase, this.dockType, $event, aModelName, wId, wKey);
        const result = await this.getAllDocks();
        this.setDisplayList(result);    
        this.closeSave();
    }

    public onAddDock() {
        this.selectedDock.forEach(element => {
            if (findItem(this.dockBase, element, 'id') === -1) {
                this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: element, display: true});
            }            
        });
        this.closeAddDock();
    }

    public deleteDock(item) {
        this.dockBase.splice(findItem(this.dockBase, item.id, 'id'), 1);
    }

    private async getAllDocks() {
        let wRes: any;
        this.docks = [];
        try {                                
            wRes = await lastValueFrom(this.api.execUrlAction('getalldocks', ''));
            this.docks = wRes.data;
            return wRes.data;
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Load_Data_KO'));
        }        
    }

    private async getDockList() {
        let wRes: any;
        this.dockList = [];
        try {                                
            wRes = await lastValueFrom(this.api.execUrlAction('getmenulist', ''));
            this.dockList = wRes.data;
            return wRes.data;
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Load_Data_KO'));
        }
    }

    private async getDocksDetails() {
        let wRes: any;
        this.docksDetails = [];
        try {                                
            wRes = await lastValueFrom(this.api.execUrlAction('getdocksdetails', ''));
            wRes.data.forEach(element => {
                this.docksDetails.push({bskname: element.bskname, iddocks: element.id_docks});
            })
            return wRes.data;
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Load_Data_KO'));
        }
    }

    private async getBasketList() {
        let wRes: any;
        wRes = await this.requestTools.getBasketList('');
        if (wRes.Status !== 'OK') {
            this.messageService.addErrorMsg(this._translate.instant('Load_Data_KO'));
        } else {
            this.basketMailList = wRes.BasketMailList.BasketMail;
            this.basketCollectList = wRes.BasketCollectList.BasketCollect;
            this.basketPublishList = wRes.BasketPublishList.BasketPublish;
            this.basketActionList = wRes.BasketActionList.BasketAction;
            this.basketInputList = wRes.BasketInputList.BasketInput;
            this.basketOutputList = wRes.BasketOutputList.BasketOutput;
            this.basketSystemList = wRes.BasketSystemList.BasketSystem;
            this.loadBasketList();
        }
    }

    private loadBasketList() {
        this.bskCollect = [];
        this.bskAction = [];
        this.bskInvoiceValidation = [];
        this.bskMailDispatching = [];
        this.bskMailValidation = [];
        this.bskMailReordering = [];
        this.setBskList(this.basketCollectList, this.bskCollect);
        this.setBskList(this.basketInputList, this.bskCollect);        
        this.setBskList(this.basketOutputList, this.bskCollect);                
        this.setBskList(this.basketActionList, this.bskAction); 
        this.setBskList(this.basketPublishList, this.bskCollect);
        this.setBskList(this.basketSystemList, this.bskCollect);                              
    }

    private setBskList(aBskList, aDestList) {
        aBskList.forEach(element => {
            switch (element.Docks.DockStandard) {
                case 'InvoiceValidation':
                    this.bskInvoiceValidation.push(element);
                    break;
                case 'MailDispatching':
                    this.bskMailDispatching.push(element);
                    break;
                case 'MailValidation':
                    this.bskMailValidation.push(element);
                    break;
                case 'MailReordering':
                    this.bskMailReordering.push(element);
                    break;
                default:
                    aDestList.push(element);
                    break;
            }
        })        
    }

    private setBasketList(aDisplay) {
        this.basketList = [];
        switch (aDisplay) {
            case 1: // 'mail'
                this.basketList = [...this.basketMailList];
                break;
            case 2: //'collect':
                this.basketList = [...this.bskCollect];
                break;
            case 3: //'action':
                this.basketList = [...this.bskAction];
                break;
            case 4: //'MailDispatching':
                this.basketList = [...this.bskMailDispatching];
                break;
            case 5: //'MailReordering':
                this.basketList = [...this.bskMailReordering];
                break;
            case 6: //'MailValidation':
                this.basketList = [...this.bskMailValidation];
                break;
            case 7: //'InvoiceValidation':
                this.basketList = [...this.bskInvoiceValidation];
                break;
        }       
        this.basketList = [...this.filterBasketList(this.basketList)];
    }

    private filterBasketList(aList) {
        let wBskExclude = [];
        wBskExclude = this.docksDetails.filter(x => x.iddocks !== this.displayList[this.selectedDisplay].id);
        aList = aList.filter(x => !this.bskIsPresent(x.Information.Name, wBskExclude));
        return aList;
    }
    
    // Vérifie si un objet existe dans un tableau
    private bskIsPresent(basketName: string, excludedList: { bskname: string }[]): boolean {
        return excludedList.some(item => item.bskname === basketName);
    }

    private async execSaveDock(aData, aDockType, aSave, aModelName, aId, aKey) {
        let wRequestData: {};
        let wModelName = '';
        if (aModelName !== '') {
            wModelName = aModelName;
        } else {
            wModelName = aKey;
        }
        wRequestData = {
            id: aId,
            name: wModelName,
            docktype: aDockType,
            docks: JSON.stringify(JSON.stringify(aData)),
            key: aKey
        };
        try {
            await lastValueFrom(this.api.execUrlAction('setmodeldocks', wRequestData));
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Update_KO'));
        }
    }

    private async execSaveBasketPos(aBasketList, aId, aKey) {
        let wRequestData: {};
        wRequestData = {
            id: aId,
            basketList: aBasketList,
            key: aKey
        };
        try {
            await lastValueFrom(this.api.execUrlAction('setbasketdocks', wRequestData));
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Update_KO'));
        }
    }

    private async execSaveDetailPos(aName, aId, aKey) {
        let wRequestData: {};
        wRequestData = {
            id: aId,
            name: aName,
            key: aKey
        };
        try {
            await lastValueFrom(this.api.execUrlAction('setdetaildocks', wRequestData));
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Update_KO'));
        }
    }

    private async execDeleteDock(aId, aKey) {
        let wRequestData: {};
        wRequestData = {
            id: aId,
            key: aKey
        };
        try {
            await lastValueFrom(this.api.execUrlAction('delmodeldocks', wRequestData));
            this.displayList = this.displayList.filter(item => item.id !== aId);
            this.selectedDisplay = -1;
            this.dockBase = [];        
            this.customModel = false;
        } catch (error) {
            this.messageService.addErrorMsg(this._translate.instant('Update_KO'));
        }
    }

    private loadDocks(aSelectedDisplay) {
        this.dockBase = [];        
        this.customModel = false;
        switch (aSelectedDisplay) {
            case 0: //'detail':
                this.getDockBase();
                break;
            case 1: //'mail':
                this.getDockMail();                
                break;                
            case 2: //'collect':
                this.getDockCollect();
                break;
            case 3: //'action':
                this.getDockAction();
                break;
            case 4: //'MailDispatching':
                this.getDockMailDispatching();
                break;
            case 5: //'MailReordering':
                this.getDockMailReordering();
                break;
            case 6: //'MailValidation':
                this.getDockMailValidation();
                break;                
            case 7: //'InvoiceValidation':
                this.getDockInvoiceValidation();
                break;                  
            default:
                this.getCustomDock(aSelectedDisplay);
                this.customModel = true;
                break;
        }
    }

    private getCustomDock(aName) {
        let wIndex = -1;
        let wKey = '';
        wIndex = findItem(this.displayList, aName, 'value');
        if (wIndex !== -1) {
            wKey = this.displayList[wIndex].key;
            wIndex = findItem(this.docks, wKey, 'name');
            if (wIndex !== -1) {
                this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
                this.dockType = this.docks[wIndex]['docktype'];
            }
        }  
    }

    private getDockBase() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_detail@', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockVersion', display: true,"x":4,"y":1});
        }
        this.dockType = 0;
    }

    private getDockMail() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@mail', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});        
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockMail', display: true});
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockIndex', display: true});        
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockBskMove', display: true});
        }
        this.dockType = 1;
    }

    private getDockCollect() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@collect', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});        
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockIndex', display: true});
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockBskMove', display: true});
        }
        this.dockType = 2;
    }

    private getDockAction() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@action', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});        
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockIndex', display: true});
        }
        this.dockType = 3;
    }

    private getDockMailDispatching() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@MailDispatching', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});                
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'maildispatching', display: true});                        
        }
        this.dockType = 4;
    }

    private getDockMailValidation() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@MailValidation', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'mailvalidation', display: true});
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockBskMove', display: true});
        }
        this.dockType = 6;
    }

    private getDockMailReordering() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@MailReordering', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {        
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});                
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'mailreordering', display: true});                                
        }   
        this.dockType = 5; 
    }

    private getDockInvoiceValidation() {
        let wIndex = -1;
        wIndex = findItem(this.docks, 'dock_bskdetail_@InvoiceValidation', 'name');
        if (wIndex !== -1) {
            this.dockBase = [...JSON.parse(JSON.parse(this.docks[wIndex]['docks']))];
        } else {
            this.dockBase = [...this.getCommon()];
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockButton', display: true});                
            this.dockBase.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'invoicevalidation', display: true});                                        
        }     
        this.dockType = 7;   
    }

    private getCommon() {
        let wTab = <any>[];
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockReorg', display: true, "x":0,"y":0});        
        wTab.push({cols: 16, rows: 8, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockVisu', display: true,"x":16,"y":0});
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockComment', display: true,"x":0,"y":1});
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockAtf', display: true,"x":0,"y":2});
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockVar', display: true,"x":0,"y":2});
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockList', display: true,"x":4,"y":2});        
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockInfos', display: true,"x":0,"y":3});                
        wTab.push({cols: this.colBase, rows: 1, maxItemCols: this.maxItemCols, minItemCols: this.minItemCols, minItemRows: this.minItemRows, id: 'dockTrace', display: true,"x":4,"y":3});                        
        return wTab;
    }

    public getDisplayList() {
        this.displayList = [];
        this.displayList.push({ key: 'dock_detail@', label: this._translate.instant('Dck_Detail'), value: 0, id: 0 });
        this.displayList.push({ key: 'dock_bskdetail_@mail', label: this._translate.instant('Dck_BMail'), value: 1, id: 0 });
        this.displayList.push({ key: 'dock_bskdetail_@collect', label: this._translate.instant('Dck_BColl'), value: 2, id: 0  });
        this.displayList.push({ key: 'dock_bskdetail_@action', label: this._translate.instant('Dck_BAct'), value: 3, id: 0  });
        this.displayList.push({ key: 'dock_bskdetail_@MailDispatching', label: this._translate.instant('Dck_DMail'), value: 4, id: 0  });
        this.displayList.push({ key: 'dock_bskdetail_@MailReordering', label: this._translate.instant('Dck_RMail'), value: 5, id: 0  });        
        this.displayList.push({ key: 'dock_bskdetail_@MailValidation', label: this._translate.instant('Dck_VMail'), value: 6, id: 0  });        
        this.displayList.push({ key: 'dock_bskdetail_@InvoiceValidation', label: this._translate.instant('Dck_VInvo'), value: 7, id: 0  });
    }

}
